// extracted by mini-css-extract-plugin
export default {"mainContent":"passwordAndSecurity_mainContent__WL+vt","container":"passwordAndSecurity_container__4XT5c"};